<template>
  <div class="logo">
    <img src="~assets/img/logo.png" alt="" />
    <span> 快叮 获客通 </span>

    <div class="lo_search">
      <!-- <div class="icon" @click="switchbar">
        <img src="~assets/img/aggregate/head1-5.png" alt="" />
      </div> -->

      <div class="Switch_themes" @click="switchthemes" v-if="0">
        <div class="themes_icon" v-show="isSunny">
          <i class="el-icon-sunny"></i>
        </div>
        <div class="themes_icon color2" v-show="!isSunny">
          <i class="el-icon-moon"></i>
        </div>
      </div>

      <div class="search_box" v-show="search_show">
        <el-popover
          trigger="focus"
          placement="bottom-start"
          popper-class="search_pover_not"
          :visible-arrow="false"
        >
          <template slot="reference">
            <div class="search_input Flex_algin">
              <el-input
                placeholder="请输入内容"
                @keyup.enter.native="fn_search"
                v-model="search_name"
                maxlength="20"
                clearable
              >
              </el-input>
              <div class="icon_box" @click="fn_search">
                <i class="el-icon-search"></i>
              </div>
            </div>
          </template>
          <div class="search_result" v-show="search_name_flag">
            <div
              class="result_item Flex_algin"
              v-for="(item, index) in result_list"
              @click="click_searchflag(index)"
            >
              <div class="names danhang" :title="`包含${search_name}的${item}`">
                包含<span>{{ search_name }}</span
                >的{{ item }}
              </div>
            </div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
	var that;
	import {
		
		
		setcacheStorage,
	
	} from "network/kh_public"
	export default {
		name: "Logo",
		data() {
			return {
				is_result: false,
				search_name: '',
				search_index: -1,
				result_list: [
					'客户',
					'联系人',
					'跟进',
					'商机',
					'合同',
					'项目',
				],
				iscollect: false,
				isSunny: true,
				search_show: true,
				
				
			}
		},
		computed:{
			search_name_flag(){
				return (this.search_name + '').trim() ? true : false;
			},
		},
		watch: {
			search_name() {
				if((this.search_name + '').trim()) {
					this.is_result = true
				}
				else {
					this.is_result = false
				}
			},
			$route: {
			  handler: function(val, oldVal){
				  let path = val.path
				  if(path == '/home/aggresearch/searchlist' || path == '/home/aggresearch') {
				  	this.search_show = false
				  }
				  else {
				  	this.search_show = true
				  }
				that.search_name = ''
			  },
			  // 深度观察监听
			  deep: true
			}
		},
		
		created() {
			that = this
			let path = this.$route.path
			if(path == '/home/aggresearch/searchlist' || path == '/home/aggresearch') {
				this.search_show = false
			}
			else {
				this.search_show = true
			}
		},
		methods: {
			switchbar(){
				this.iscollect = !this.iscollect
				
				that.$store.commit('setcollect', this.iscollect)
				this.$emit("fncollect", {flag: this.iscollect} );
			},
			switchthemes(){
				this.isSunny = !this.isSunny
				this.$emit("fnthemes", {flag: this.isSunny} );
			},
			click_searchflag(index){
				this.search_index = index * 1
				this.fn_search()
			},
			
			fn_search() {
				// this.$alertMess('抱歉,当前页面维护中,暂时无法使用', 'error')
				let val = (this.search_name + '').trim()
				if (val) {
					
					setcacheStorage(val)
					
					let search_index = ''
					if(this.search_index != -1) {
						search_index = this.search_index + 1
					}
					
					this.$router.push({
						path: '/home/aggresearch/searchlist',
						query: {
							search_name: val,
							search_index,
						},
					})
				
					
					setTimeout(()=>{
						this.search_name = ''
						this.search_index = -1
						this.is_result = false
					}, 300)
				} else {
					this.search_name = ''
					this.$alertMess('请输入内容', 'error')
				}
			},
			
			handlereq(res) {
				if (res) {
					if (res.code === 10000) { // 请求成功
						return true
					} else { // 请求发生错误
						this.alertMess(res.message, 'error')
						return false
					}
				}
			},
			// ----------------------------------------------
			// 弹出提示------
			alertMess(message, type) {
				this.$message({
					showClose: true,
					offset: 100,
					duration: 2000,
					message,
					type: type ? type : 'success',
				});
			},
			
			
		}
	}
</script>

<style scoped lang="scss">
.themes_sunny {
}

.themes_moon {
}

.lo_search {
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 35px;

  .Switch_themes {
    margin: 0 20px;
    cursor: pointer;

    .themes_icon.color2 {
      i {
        color: #fff;
      }
    }

    .themes_icon {
      i {
        font-size: 20px;
        color: #b3b6c2;
      }
    }
  }

  .icon {
    cursor: pointer;
    width: 16px;

    img {
      height: 16px;
      width: 16px;
      display: block;
    }
  }
}

@media screen and (max-width: 750px) {
  .search_box{
    display: none;
  }
}
.search_box {
  margin-left: 24px;
  position: relative;

  .search_input {
    padding-right: 30px;
    display: flex;
    align-items: center;
    width: 280px;
    position: relative;

    /deep/ .el-input {
      input {
        width: 280px;
        height: 35px !important;
        padding-right: 60px !important;
      }
    }

    .icon_box:hover {
      i {
        color: rgba(43, 117, 235, 1);
      }
    }

    .icon_box {
      position: absolute;
      right: 14px;
      cursor: pointer;

      i {
        color: rgba(162, 165, 180, 1);
      }
    }
  }
}

.search_result {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(241, 242, 244, 1);
  background-color: #fff;
  width: 280px;

  .result_item:last-of-type {
    border-bottom: 0;
  }

  .result_item {
    cursor: pointer;
    padding: 0 14px;
    height: 45px;
    display: flex;
    align-items: center;
    border-bottom: solid 1px rgba(241, 242, 244, 1);

    .names {
      font-size: 14px;
      color: rgba(80, 80, 80, 1);
      max-width: 240px;

      span {
        font-size: 14px;
        margin: 0 1px;
        display: inline-block;
        color: rgba(43, 117, 235, 1);
      }
    }
  }
}

.logo {
  /* position: absolute; */
  /* width: 40px; */
  /* height: 40px; */
  /* left: 18px; */
  /* top: 10px; */
  display: flex;
  align-items: center;

  > img {
    width: 40px;
    display: block;
    height: 40px;
    margin-right: 8px;
  }
  @media screen and (max-width: 490px){
    span{
    display: none;
  }
  }
  span {
    white-space: nowrap;
    font-size: 20px;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
  }
}
</style>
